import {boot} from 'quasar/wrappers'
import VueSafeHTML, {allowedTags} from 'vue-safe-html'

export default boot(({app}) => {
  app.use(VueSafeHTML, {
    allowedTags: [...allowedTags, 'ul', 'li', 'span', 'div', 'hr', 'ol', 'strike', 'u', 'p', 'br'],
    allowedAttributes: ['style', 'class'],
  })
})
